module.exports = __webpack_public_path__ + "img/section2.5cb5eee1.jpeg";